import { render, staticRenderFns } from "./OInput.vue?vue&type=template&id=dbd4c25c&scoped=true"
import script from "./OInput.vue?vue&type=script&lang=js"
export * from "./OInput.vue?vue&type=script&lang=js"
import style0 from "./OInput.vue?vue&type=style&index=0&id=dbd4c25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd4c25c",
  null
  
)

export default component.exports